import { createMuiTheme } from '@material-ui/core/styles'

import blueGrey from '@material-ui/core/colors/blueGrey'

const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}

export default createMuiTheme({
  palette: {
    primary: {
      ...blueGrey,
      main: blueGrey[500],
      contrastText: '#fff'
    }
  },
  breakpoints: { values: breakpointValues }
})
